import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ChevronDoubleDownFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 12.18L4.64 4.82L6.06 3.4L12 9.34L17.94 3.4L19.36 4.82L12 12.18ZM12 19.76L4.64 12.4L6.06 10.98L12 16.92L17.94 10.98L19.36 12.4L12 19.76Z" />
    </SvgIcon>
  );
});
